import { codigoExternoSchema, type EmpresaDetalhe } from '@fiscoai/contracts';

import { useSubstituirLista } from './api';
import { ListaEditavel } from './lista-editavel';

/** Como esta empresa é identificada em cada sistema conectado (ADR 0021): um código por conector. */
export function AbaIntegracoes({
  empresa,
  podeEditar,
}: {
  empresa: EmpresaDetalhe;
  podeEditar: boolean;
}) {
  const codigos = useSubstituirLista(empresa.id, 'codigos-externos');
  return (
    <ListaEditavel
      titulo="Códigos em outros sistemas"
      descricao="Usados pelos conectores para achar esta empresa no ERP, no sistema de compras e afins. O identificador do conector vem da instalação."
      item={codigoExternoSchema}
      colunas={[
        { nome: 'conectorId', rotulo: 'Conector', tipo: 'texto', mono: true },
        { nome: 'codigo', rotulo: 'Código da empresa lá', tipo: 'texto', mono: true },
      ]}
      valores={empresa.codigosExternos}
      novoItem={{ conectorId: '', codigo: '' }}
      podeEditar={podeEditar}
      salvar={(itens) => codigos.mutateAsync(itens)}
      salvando={codigos.isPending}
    />
  );
}
